<template>
    <div class="issued-task">
        <div class="task-head">
            <div class="text-main">
                <div class="task-name">{{task.taskName}}</div>
                <div class="task-status">{{getTaskStatus(task)}}</div>
                <div class="read-status">{{getCurrStatus(userCode)}}</div>
            </div>
            <img src="../../assets/image/task/header.svg" />
        </div>
        <div class="content-main" v-if="!emptyShow">
            <van-row v-if="task.taskType != '0'">
                <van-col class="label" span="5">所属分组:</van-col>
                <van-col span="19">{{taskGroup.groupName}}</van-col>
                <van-col class="label" span="5">组管理员:</van-col>
                <van-col span="19">{{taskGroup.groupUserNames}}</van-col>
            </van-row>
            <van-row>
                <van-col class="label" span="5">发起部门:</van-col>
                <van-col span="19">{{task.deptName}}</van-col>
                <van-col class="label" span="5">填报时间:</van-col>
                <van-col span="19">
                    <p>【{{moment(task.startTime).format('Y年M月d日')}}】开始</p>
                    <p>{{getEndTime(task.endTime)}}</p>
                </van-col>
            </van-row>
            <van-row v-if="task.taskDesc">
                <van-col class="label" span="5">填报说明:</van-col>
                <van-col span="24">{{task.taskDesc}}</van-col>
            </van-row>
            <van-row v-if="fileList.length > 0">
                <van-col class="label" span="5">附件:</van-col>
                <van-col span="24" v-for="file in fileList" :key="file.id"
                         @click="onPreviewFile(file.fileType, file.downloadUrl)">
                    <van-icon name="orders-o" />
                    {{file.originalFileName+'.'+file.fileType}}
                </van-col>
            </van-row>
        </div>
        <div class="content-main" v-else>
            <Error type="empty"/>
        </div>
        <div class="footer" v-if="!emptyShow">
            <van-button plain hairline size="small" type="info" block @click="locationTo('ybt/task/handleForMobile.htm?taskId='+task.id+'_'+groupId)">填报</van-button>
        </div>
    </div>
</template>

<script>
    import { Col, Row, Icon, Button} from 'vant';
    import {queryIssuedTaskDetail} from "@/api/my-items"
    import {locationTo} from '@/utils/url'
    import {FILE_TYPE_IMAGE, parseFileType, previewFile, previewImage} from "@/utils/file";
    import moment from 'moment'
    moment.locale('zh-cn');
    export default {
        name: 'IssuedTaskDetail',
        components: {
            [Col.name]: Col,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Button.name]: Button
        },
        data() {
            return {
                task:{
                    taskName:"",
                    deptName:"",
                    taskDesc:"",
                    taskType:"0",
                },
                taskGroup:{
                    groupUserNames:"",
                    groupName:""
                },
                userCode:"",
                responsibler:{

                },
                taskId:"",
                groupId:"",
                loading: false,
                error: false,
                emptyShow: false //空空如也是否显示
            }
        },
        computed: {
            fileList(){
                let fileList = JSON.parse(this.task.taskFiles||'[]');
                return fileList;
            }
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                let busIds = to.params.taskId.split("_")
                vm.taskId = busIds[0];
                vm.goupId = busIds[1]||'';
                vm.onLoad(vm.taskId,vm.goupId)
            })
        },
        beforeRouteUpdate(to, from, next) {
            let busIds = to.params.taskId.split("_")
            this.taskId = busIds[0];
            this.goupId = busIds[1]||'';
            this.onLoad(this.taskId,this.goupId)
            next()
        },
        methods: {
            moment,
            locationTo,
            onLoad(taskId,groupId) {
                this.loading = true;
                queryIssuedTaskDetail(taskId,groupId)
                    .then(resp => {
                        this.task = resp.task;
                        this.responsibler = resp.responsibler;
                        this.userCode = resp.userCode;
                        this.taskGroup = resp.taskGroup;
                        // this.list = this.list.concat(resp.data)
                        // if (this.list.length >= resp.total)
                        // if (!resp.total) {
                        //   this.emptyShow = true;
                        // } else {
                        //   this.emptyShow = false;
                        // }
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        this.error = true
                    })
                    .finally(() => {
                      this.loading = false;
                    })
            },
            getEndTime(endTime){
                if(moment().isBefore(endTime)){
                    return "【"+moment(endTime).toNow(true )+"】内允许填报"
                }else{
                    return "【"+moment(endTime).format('Y年M月d日 H时m分')+"】结束"
                }
            },
            getTaskStatus(task){
                let msg = "任务";
                let smg = "";
                if(moment().isBefore(task.startTime)){
                    smg = "未开始"
                }else if(!moment().isBefore(task.endTime)){
                    smg = "已结束"
                }else{
                    if(task.status == "0"){
                        smg = "已暂停"
                    }else{
                        smg = "进行中"
                    }
                }
                return msg+smg;
            },
            getCurrStatus(userCode){
                if(userCode === 9009){
                    return "当前状态：已填报";
                }else if(this.responsibler){
                    return "当前状态：未填报";
                }else {
                    return ""
                }
            },
            onPreviewFile(fileType, downloadUrl) {
                if (parseFileType(fileType.toLowerCase()) === FILE_TYPE_IMAGE) {
                    previewImage([complete(downloadUrl)]);
                } else {
                    previewFile(parseFileType(fileType.toLowerCase()), downloadUrl)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .issued-task {
        background-color: #efeff4;
        height: calc(100% - 20px);;
        padding: 0 10px 10px;
        position: relative;
        .task-head{
            height: 20%;
            background-color: #1e7fff;
            border-radius: 10px;
            position: relative;
            img {
                position:absolute;
                width: 25%;
                height: 80%;
                right: 0px;
                bottom: 0px;
            }

            .text-main{
                position: relative;
                height: 100%;
                box-sizing: border-box;
                padding: 20px 15px;
                border-width: 0px;
                font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
                font-weight: 700;
                font-style: normal;
                color: #FFFFFF;
                .task-name{
                    font-size: 18px;
                    text-align: left;
                }
                .task-status{
                    line-height: 25px;
                    font-size: 14px;
                    text-align: left;
                }
                .read-status{
                    font-size: 14px;
                    position:absolute;
                    bottom: 20px;
                    left: 15px;
                }
            }
        }

        .content-main{
            height: calc(80% - 60px);
            box-sizing:border-box;
            margin-top: 10px;
            background-color: #FFFFFF;
            border-radius: 10px;
            padding: 20px 15px;
            overflow: auto;
            .van-col{
                font-size: 12px;
                font-family: 'Arial Normal', 'Arial', sans-serif;
                font-weight: 400;
                padding: 2px 0;
                line-height: 25px;
            }
            .label{
                font-size: 14px;
                color: #333333 !important;
                font-weight: bold;
            }
        }

        .footer{
            width: 100%;
            background-color: #ffffff;
            padding: 10px 20px;
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            left: 0;
            .van-button--hairline::after{
                border-radius: 15px;
            }
        }
    }
</style>
